import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'timeCode';

export class TimeCode extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
